setTimeout(() => {
  const swatches = document.getElementsByClassName("single-option-selector");
      console.log("qqqwq")
  for (let i = 0; i < swatches.length; i++) {
    swatches[i].addEventListener("click", getDiscountedPrice);
  }
}, 700);

function getDiscountedPrice() {
  var oldVariant = document.getElementsByClassName("axt-cp-custom")[0].id;
  var oldProduct = document.getElementsByClassName("axt-cp-custom")[0].getAttribute("axt-cp-product-id");
  
  setTimeout(() => {      
      // Remove old variant and product IDs
    document.getElementsByClassName("axt-cp-custom")[0].classList.remove(oldVariant);
    document.getElementsByClassName("axt-cp-custom")[0].classList.remove(oldProduct);

    var variantId = document.querySelector('[name="id"]').value;
    var productId = document.querySelector('[name="product-id"]').value;

    // Add new variant and product IDs
    document.getElementsByClassName("axt-cp-custom")[0].classList.add(variantId);
    document.getElementsByClassName("axt-cp-custom")[0].classList.add(productId);

    document.getElementsByClassName("axt-cp-custom")[0].id = productId;
    document.getElementsByClassName("axt-cp-custom")[0].setAttribute("axt-cp-product-id", variantId);
  }, 700);
}